export default __webpack_public_path__ + "media/images/icons/house-person-24aa07c847c9dd1f247aef47ce597ad0.svg";